import * as React from 'react';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { ConnectChildren } from '@pec/aion-ui-core/types/connectChildren';
import { getOptionsIfNeeded, toggleNavExpandedSectionId } from '@pec/aion-ui-core/actions/options';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { SectionComponent } from '../../components/Nav/Section';
import { ThunkDispatch } from 'redux-thunk';

type OwnProps = {
  id: string;
  subheader: string;
  icon: JSX.Element;
  hasNotifications?: boolean;
  tooltip?: boolean;
  isBold?: boolean;
};

const mapStateToProps = ({ options: { navExpandedSectionIds, navExpanded } }: CommonRootState, { id }: OwnProps) => ({
  expanded: navExpandedSectionIds.includes(id),
  navExpanded
});

const mapDispatchToProps = (dispatch: ThunkDispatch<CommonRootState, null, RootActions>, { id }: OwnProps) => ({
  getOptionsIfNeeded: () => dispatch(getOptionsIfNeeded()),
  toggleNavExpandedSectionId: () => dispatch(toggleNavExpandedSectionId(id))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps & ConnectChildren;

class Section extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.getOptionsIfNeeded();
    if (!props.expanded && props.id === process.env.REACT_APP_NAME) {
      this.props.toggleNavExpandedSectionId();
    }
  }

  handleExpand = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    this.props.toggleNavExpandedSectionId();
  };

  render() {
    const { expanded, navExpanded, hasNotifications, ...props } = this.props;
    return (
      <SectionComponent
        expanded={expanded && navExpanded}
        navExpanded={navExpanded}
        showDotBadge={hasNotifications && (!navExpanded || !expanded)}
        handleExpand={this.handleExpand}
        {...props}
      />
    );
  }
}

export const SectionContainer = connect(mapStateToProps, mapDispatchToProps)(Section);
